// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishListGroupForm-marginLeft-K8OdA{
    margin-left: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/WishLists/WishListGroupForm/WishListGroupForm.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB","sourcesContent":[".marginLeft{\n    margin-left: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"marginLeft": `WishListGroupForm-marginLeft-K8OdA`
};
module.exports = ___CSS_LOADER_EXPORT___;
